import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import Vueaxios from "vue-axios";
import "./registerServiceWorker";
import store from "./store";

Vue.use(Vueaxios, axios);
Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
